<template>
    <a-card :title="c_title">
        <div slot="extra" style="width:200px;float:right;">
            <v-gobackbutton>返回</v-gobackbutton>
            <a-button type="primary" class="fr mr20" slot="extra" @click="handleAll">探测所有节点</a-button>
        </div>

        <a-descriptions bordered v-for="item in data" :key="item.node" class="mb30">
            <a-descriptions-item label="节点IP">{{item.node}}</a-descriptions-item>
            <a-descriptions-item v-if="item.result.currenttime" label="探测时间">{{item.result.currenttime}}</a-descriptions-item>
            <a-descriptions-item label="操作">
                <a-button type="primary" @click="handleCurrent(item.node)">探测</a-button>
            </a-descriptions-item>

            <a-descriptions-item label="DUBBO" :span="3" v-if="item.result.dubbo">
                <div class="myflex">
                    <div class="server" v-if="item.result.dubbo.status">
                        <a-icon class="dataBaseIcon" type="database" />
                        <div class="status_block">
                            <p>状态：<a-badge :status="item.result.dubbo.status == 'normal' ? 'success' : 'error'" :text="StatusText[item.result.dubbo.status]" class="status_text" /></p>
                            <p>延迟：{{item.result.dubbo.delay}} ms</p>
                            <a-popover title="详情" v-if="item.result.dubbo.errormsg">
                                <template #content>
                                    <p><span class="c0">错误：</span>{{item.result.dubbo.errormsg}}</p>
                                </template>
                                其他：<a-button type="link" class="mt10" size="small">详情</a-button>
                            </a-popover>
                        </div>
                    </div>
                </div>
                
            </a-descriptions-item>
            <a-descriptions-item label="DB" :span="3" v-if="item.result.db">
                <div class="myflex">
                    <div class="server" v-for="(db,index) in item.result.db" :key="index">
                        <a-icon class="dataBaseIcon" type="database" />
                        <div class="status_block">
                            <p>状态：<a-badge :status="db.status == 'normal' ? 'success' : 'error'" :text="StatusText[item.result.dubbo.status]" class="status_text" /></p>
                            <p>延迟：{{db.delay}} ms</p>
                            <a-popover title="详情">
                                <template #content>
                                    <p v-if="db.errormsg"><span class="c0">错误：</span>{{item.result.dubbo.errormsg}}</p>
                                    <p><span class="c0">IP端口：</span>{{db.ipport}}</p>
                                    <p><span class="c0">数据库连接url：</span>{{db.url}}</p>
                                </template>
                                其他：<a-button type="link" class="mt10" size="small">详情</a-button>
                            </a-popover>

                        </div>
                    </div>
                    <span v-if="item.result.db.length == 0" class="pl15">无节点</span>
                </div>
            </a-descriptions-item>
            <a-descriptions-item label="REDIS-default" :span="3" v-if="item.result.redis">
                <div class="myflex">
                    <div class="server" v-for="(redis_d,index) in item.result.redis['default.redis.shardConfig']" :key="index">
                        <a-icon class="dataBaseIcon" type="database" />
                        <div class="status_block">
                            <p><span class="c0">IP端口：</span>{{redis_d.ipport}}</p>
                            <p>状态：<a-badge :status="redis_d.status == 'normal' ? 'success' : 'error'" :text="StatusText[item.result.dubbo.status]" class="status_text" /></p>
                            <p>延迟：{{redis_d.delay}} ms</p>
                        </div>
                    </div>

                </div>
            </a-descriptions-item>
            <a-descriptions-item label="REDIS-passport" :span="3" v-if="item.result.redis">
                <div class="myflex">
                    <div class="server" v-for="(redis_p,index) in item.result.redis['passport.redis.shardConfig']" :key="index">
                        <a-icon class="dataBaseIcon" type="database" />
                        <div class="status_block">
                            <p><span class="c0">IP端口：</span>{{redis_p.ipport}}</p>
                            <p>状态：<a-badge :status="redis_p.status == 'normal' ? 'success' : 'error'" :text="StatusText[item.result.dubbo.status]" class="status_text" /></p>
                            <p>延迟：{{redis_p.delay}} ms</p>
                        </div>
                    </div>

                </div>
            </a-descriptions-item>
            <a-descriptions-item label="REDIS-fk" :span="3" v-if="item.result.redis">
                <div class="myflex">
                    <div class="server" v-for="(redis_f,index) in item.result.redis['fk.redis.shardConfig']" :key="index">
                        <a-icon class="dataBaseIcon" type="database" />
                        <div class="status_block">
                            <p><span class="c0">IP端口：</span>{{redis_f.ipport}}</p>
                            <p>状态：<a-badge :status="redis_f.status == 'normal' ? 'success' : 'error'" :text="StatusText[item.result.dubbo.status]" class="status_text" /></p>
                            <p>延迟：{{redis_f.delay}} ms</p>
                        </div>
                    </div>

                </div>
            </a-descriptions-item>
            <a-descriptions-item label="线程池" :span="3" v-if="item.result.threadPools">
                <div class="myflex">
                    <a-table v-if="item.result.dubboPool.length > 0" :columns="columns"  :data-source="item.result.dubboPool" :pagination="false" rowKey="poolKey" >
                        <template #title>
                            <h1>DubboPool</h1>
                        </template>

                        <template slot="loadID" slot-scope="text">
                            <span :class="getLoadClass(text)">{{text}}</span>
                        </template>
                    </a-table>

                    <a-table v-if="item.result.hystrixPool.length > 0" :columns="columns"  :data-source="item.result.hystrixPool" :pagination="false" rowKey="poolKey" >
                        <template #title>
                            <h1>HystrixPool</h1>
                        </template>

                        <template slot="loadID" slot-scope="text">
                            <span :class="getLoadClass(text)">{{text}}</span>
                        </template>
                    </a-table>

                    <a-table v-if="item.result.springPool.length > 0" :columns="columns"  :data-source="item.result.springPool" :pagination="false" rowKey="poolKey" >
                        <template #title>
                            <h1>SpringPool</h1>
                        </template>

                        <template slot="loadID" slot-scope="text">
                            <span :class="getLoadClass(text)">{{text}}</span>
                        </template>
                    </a-table>
                </div>
            </a-descriptions-item>
        </a-descriptions>
    </a-card>
</template>




<script>
const StatusText = {
    'error':'异常',
    'normal':'正常'
}
const columns = [
    {
        title: 'Key',
        dataIndex: 'poolKey',
    },
    {
        title: '核心线程',
        dataIndex: 'corePoolSize',
    },
    {
        title: '最大线程',
        dataIndex: 'maximumPoolSize',
    },
    {
        title: '活跃线程',
        dataIndex: 'activeSize',
    },
    {
        title: '当前线程数',
        dataIndex: 'poolSize',
    },
    {
        title: '队列最大数量',
        dataIndex: 'queueCapacity',
    },
    {
        title: '队列当前数量',
        dataIndex: 'queueSize',
    },
    {
        title: '已完成任务数',
        dataIndex: 'completedTaskCount',
    },
    {
        title: '线程池负载',
        dataIndex: 'currentLoad',
        scopedSlots: { customRender: 'loadID' },
    },
];



export default {
    data(){
        return {
            data:[],
            tLoading:false,
            c_title:'',
            StatusText,
            columns
        }
    },

    methods:{
        getLoadClass(text){
            let num = parseFloat(text);
            if(num < 0.8){
                return 'green'
            }
            else if(num < 0.9){
                return 'yellow'
            }
            else{
                return 'red'
            }
        },
        getAppnode(){
            const { query} = this.$route;
            this.tLoading = true;
            this.c_title = query.appenname + '节点'
            let c_params = {
                ...query,
                urlparams:false,
            }
            this.$store.dispatch({
                type: "app/selectAppNode",
                params:c_params
            }).then((res)=>{
                this.tLoading = false;
                //处理线程池数据
                this.data = this.handlePool(res.data.data)
            })
        },
        handlePool(data){
            data.forEach(element => {
                var target = element.result;
                if(target.threadPools){
                    var tItem = target.threadPools.dubboPool;
                    target.dubboPool = this.handlePoolItem(tItem);
                    tItem = target.threadPools.hystrixPool;
                    target.hystrixPool = this.handlePoolItem(tItem);
                    tItem = target.threadPools.springPool;
                    target.springPool = this.handlePoolItem(tItem);

                }
            });
            console.log(data)
            return data
        },
        handlePoolItem(pool){
            let result = [];
            if(pool){
                for (const key in pool) {
                    if (Object.hasOwnProperty.call(pool, key)) {
                        const element = pool[key];
                        element.poolKey = key;
                        result.push(element)
                    }
                }
            }
            return result
        },
        handleAll(){
            let that = this;
            const { query} = this.$route;
            this.tLoading = true;
            let c_params = {
                appcode:query.appcode,
                domain:query.domain,
                version:query.version
            }
            this.$store.dispatch({
                type: "app/refreshAppNode",
                params:c_params
            }).then((res)=>{
                this.tLoading = false;
                if(res.data.success == '1'){
                    this.getAppnode();
                    that.message.success('刷新成功')
                }
                else{
                    that.message.error('刷新失败')
                }
            })
        },
        handleCurrent(targetip){
            let that = this;
            const { query} = this.$route;
            this.tLoading = true;
            let c_params = {
                appcode:query.appcode,
                domain:query.domain,
                version:query.version,
                targetip:targetip
            }
            this.$store.dispatch({
                type: "app/refreshOneAppNode",
                params:c_params
            }).then((res)=>{
                this.tLoading = false;
                if(res.data.success == '1'){
                    this.getAppnode();
                    that.message.success('刷新成功')
                }
                else{
                    that.message.error('刷新失败')
                }
            })
        }
    },
    mounted(){
        this.getAppnode()
    }
};
</script>

<style scoped>
.dataBaseIcon{
    font-size: 40px;
    /* color: #1890ff; */
}
.server{
    display: flex;
    width: 250px;
    margin: 10px;
    flex-wrap: wrap;
    justify-content: flex-start;
}
.myflex{
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
}

.status_block{
    margin-left: 20px;
}

.status_block p{
    width: 190px;
    margin: 0;
    word-break: break-all;
}

.red{
    color: red;
    font-weight: bold;
}

.yellow{
    color: yellow;
    font-weight: bold;

}

.green{
    color: green;
    font-weight: bold;

}

</style>